const EVENTS = {
  screenVisited: 'SCREEN_VISITED',
  signedIn: 'SIGNED_IN',
  websiteOpened: 'WEBSITE_OPENED',
};

export { EVENTS };
